import { BsShieldCheck } from "react-icons/bs";
import { IoAirplaneOutline } from "react-icons/io5";

// import hallmarked from ".";
const features = [
  {
    icon: (
      <img
        src="https://d1lfl311x81a6w.cloudfront.net/products/1730092654701.png"
        alt="Easy Return"
        loading="lazy"
        className="w-6 h-6 md:w-12 md:h-12 object-contain"
      />
    ),
    title: "Easy 90 Days Return & Exchange",
  },
  {
    icon: (
      // <IoAirplaneOutline className="text-[#808080] group-hover:text-[#000080] w-12 h-12 -rotate-45" />
      <IoAirplaneOutline className="w-6 h-6 md:w-12 md:h-12 -rotate-45 text-[#808080]" />
    ),
    title: "Free Shipping on All Orders",
  },
  {
    icon: (
      <img
        src="/svg/hallmarked.svg"
        alt="BIS Hallmarked"
        loading="lazy"
        className="w-7 h-6 md:w-14 md:h-12 object-contain"
      // className="w-14 h-12 object-contain filter grayscale invert group-hover:invert-0"
      />
    ),
    title: "BIS Hallmarked Jewellery",
  },
  {
    icon: <BsShieldCheck className="w-6 h-6 md:w-12 md:h-12 text-[#808080]" />,
    title: "100% Safe Secure Checkout",
  },
  {
    icon: (
      <img
        src="/svg/signature.svg"
        alt="Customized Engraving"
        loading="lazy"
        className="w-6 h-6 md:w-12 md:h-12 object-contain"
      />
    ),
    title: "Customized Engraving",
  },
  {
    icon: (
      <img
        src="/svg/certificate.svg"
        alt="Authentication Certificate"
        loading="lazy"
        className="w-6 h-6 md:w-12 md:h-12 object-contain"
      />
    ),
    title: "Authentication Certificate",
  },
];

export default function SairahExperience() {
  return (
    // <section className="bg-gradient-to-br from-white via-[#f1f4ff] to-[#e8ecff] py-10 px-4">
    <section className="bg-[#F3F3FD] py-4 md:py-10 px-4">
      <h2 className="text-center text-lg md:text-2xl font-bold uppercase mb-4 md:mb-12 tracking-wide">
        The <span className="text-[#000080]">Sairah</span> Experience
      </h2>

      <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-2 md:gap-6 max-w-7xl mx-auto">
        {features.map((feature, index) => (
          <div
            key={index}
            className="bg-white rounded-lg md:rounded-xl shadow-md hover:shadow-xl hover:scale-105 transition-all duration-300 p-3 md:p-6 flex flex-col items-center text-center group border border-[#000080]/10"
          >
            <div className="mb-2 md:mb-4 transform transition-transform group-hover:scale-110">
              {feature.icon}
            </div>
            <p className="text-[10px] md:text-sm font-medium text-[#333] group-hover:text-[#000080] transition-colors duration-300">
              {feature.title}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}